import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import {environment} from './environments/environment';

console.log('Environment:', environment.name);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
